export const translations = {
  date: {
    months: [null, 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
  },
  defaultLabels: ['Día', 'Mes', 'Año'],
  defaultPlaceholder: ['--', '--', '--'],
};
